import React, { PropTypes } from 'react';
import { FontIcon, CardHeader, Card, CardText } from 'material-ui';
import { Link } from 'react-router';
import moment from 'moment';
// import FieldNamesToFormalNames from '../../../utils/contracting-fieldName-to-formalNames';
// import R from 'ramda';
import ImportFields from './import-fields-activity-feed';
import { getStatusColor, getStatusIcon } from '../contractingUtils';
import EditHistories from '../generic-components/editHistories';
import { fileUrls } from '../../../api';


const ActivityWithIcon =
  ({
    action,
    statusChanged,
    file,
    version,
    amendment,
    editHistory,
    diffSummary,
    lastVersionId,
    currentVersionId,
    importedFields,
    className,
    diff,
   }) => {
    const isForAnUpdates = action === 'Contract Updated' || (diffSummary && diffSummary.summaryByPage.length);
    if (!statusChanged && !file && !amendment && !isForAnUpdates && !importedFields && !diff) {
      return <span/>;
    }
    const { icon, bgColor, color } = (() => {
      if (statusChanged) {
        const newStatus = statusChanged === 'received externally' ? 'received' : statusChanged;
        return {
          icon: getStatusIcon(newStatus),
          bgColor: 'white',
          color: getStatusColor(newStatus),
        };
      } else if (amendment) {
        return {
          icon: 'tc-icon-receipt',
          bgColor: '#e6e6e6',
          color: '#616061',
        };
      } else if (isForAnUpdates) {
        return {
          icon: 'tc-icon-change_history',
          bgColor: '#e6e6e6',
          color: '#616061',
        };
      } else if (file) {
        return {
          icon: 'tc-icon-attach_file',
          bgColor: '#e6e6e6',
          color: '#616061',
        };
      }
      return {};
    })();
    const diffMap = {
      priority: {
        label: 'Priority',
        getValue: val => val || 'Medium',
      },
      rateConversionStatus: {
        label: 'Status',
        getValue: val => val,
      },
      rateConversionSetting: {
        label: 'Require Supplier Signature',
        getValue: val => val === 'opt-in' ? 'Yes' : 'No',
      },
      shouldSendReminders: {
        label: 'Auto Reminders',
        getValue: val => val ? 'ON' : 'OFF',
      },
      assignee: {
        label: 'Assignee',
        getValue: val => val ? (val.name || val.email || 'Unassigned') : 'Unassigned',
      },
      state: {
        label: 'Status',
        getValue: val => val,
      },
      'Contract Period': {
        label: 'Contract Period',
        getValue: val => val,
      },
    };
    const textNode = (() => {
      if (file) {
        const downloadUrl = fileUrls.getDownloadUrlSync(file.hash || file.downloadUrl || file.path);
        return (
          <a href={downloadUrl} download={file.fileName || file.name}>
            <small style={{ marginLeft: '5px', color: '#616061' }}>
              {file.fileName || file.name}
            </small>
          </a>);
      }
      if (statusChanged) {
        if (statusChanged === 'received externally') {
          return <small style={{ marginLeft: '5px' }}>marked as <span style={{ color }}>received</span></small>;
        }
        return <small style={{ marginLeft: '5px' }}>status changed to <span style={{ color }}>{statusChanged}</span></small>;
      }
      if (amendment) return <small style={{ marginLeft: '5px' }}>added <a href={amendment.downloadUrl}><span style={{ color: '#00b3cf' }}>amendment</span></a></small>;
      if (isForAnUpdates) return <small style={{ marginLeft: '5px' }}>modified the contract <span style={{ color: '#00b3cf' }}>Learn more</span></small>;
      if (diff && diff.key && diffMap[diff.key]) return <div>Changed <b>{diffMap[diff.key].label}</b> from <i>{diffMap[diff.key].getValue(diff.oldValue)}</i> to <b>{diffMap[diff.key].getValue(diff.newValue)}</b></div>;
      return <div/>;
    })();

    // const anchorSwitch = (sectionName) => {
    //   const route = `/contracting/contract/${contractId}/details`;
    //   if (sectionName === 'Edit Billing Info') return <a href={`${route}#billingInfo`}>{sectionName}</a>;
    //   if (sectionName === 'Edit Policy Info') return <a href={`${route}#cancellationPolicy`}>{sectionName}</a>;
      // if (sectionName === 'Edit Policy Info') return <Link to={{ pathname: route, hash: '#cancellationPolicy' }}>{sectionName}</Link>;
      // if (sectionName === 'Edit Policy Info') return <FlatButton label={sectionName} onTouchTap={jumpToSection}/>;
    // };

    if (isForAnUpdates) {
      return (
        <Card style={{ boxShadow: 'none' }}>
          <CardHeader
            style={{ height: '24px', padding: '0' }}
            title={<div style={{ lineHeight: '20px', marginBottom: '12px' }}>
              <div style={{ width: '22px', height: '22px', borderRadius: '50%', backgroundColor: bgColor, lineHeight: '20px', display: 'inline-block' }}>
                <FontIcon className={icon} color={color} style={{ fontSize: '16px', left: '3px', top: '2px' }}/>
              </div>
              <small style={{ marginLeft: '5px', color: 'rgba(0, 0, 0, 0.54)' }}>
                This contract has been updated {version ? <span>to <b>version {version}</b> </span> : ''}<span style={{ color: '#00b3cf' }}>View all updates</span>
              </small>
            </div>}
            actAsExpander
          />
          <CardText expandable style={{ padding: '0 0 0 12px', marginBottom: '12px' }}>
            <EditHistories
              editHistory={editHistory}
              diffSummary={diffSummary}
            />
            <Link to={`/contracting/reports/diff/contract/${currentVersionId}/${lastVersionId}`} style={{ color: '#00b3cf' }}>View side by side comparison</Link>
          </CardText>
        </Card>
      );
    }
    if (importedFields) return <ImportFields importedFields={importedFields} contractId={currentVersionId} />;
    return (
      <div style={{ lineHeight: '20px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} className={className}>
      {
        icon ? (<div style={{ width: '22px', height: '22px', borderRadius: '50%', backgroundColor: bgColor, lineHeight: '20px', display: 'inline-block' }}>
          <FontIcon className={icon} color={color} style={{ fontSize: '16px', left: '3px', top: '2px' }}/>
        </div>) : undefined
      }
        {textNode}
      </div>
    );
  };

ActivityWithIcon.propTypes = {
  className: PropTypes.string,
  diff: PropTypes.object,
  editHistory: PropTypes.array,
  file: PropTypes.object,
  statusChanged: PropTypes.string,
  type: PropTypes.string,
};

export default ActivityWithIcon;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/activity-with-icon.jsx